import React from "react";
import Payment from "../../Components/Money/PaymentList";
// import LeftMenu from "../../Components/LeftMenu";
import queryString from "query-string";

const PaymentPage = ({ match, location }) => {
  const query = queryString.parse(location.search);
  return (
    <React.Fragment>
      {/* <LeftMenu /> */}
      <Payment date={query.date} />
    </React.Fragment>
  );
};

export default PaymentPage;
